import PageWrapper from './PageWrapper'

export default PageWrapper
